import { Grid } from "@mui/material";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import MxFormDescriptionTitle from "@rf-l1/page/form/MxFormDescriptionTitle";
import LinksFormSections from "./LinksFormSections";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import CarruselImagesFormSection from "./carrucel-images-property/CarrucelImagesFormSection";

const MultimediaStep = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MxFormSubTitleAndDescription
          label="Multimedia"
          description="Elige las mejores vistas y logra que tu propiedad cause sensación."
          isRequired
        />
      </Grid>

      <Grid item xs={12}>
        <CarruselImagesFormSection />
      </Grid>

      <Grid container item xs={12} spacing={2} pr={2}>
        <Grid container item xs={12} spacing={0.5} gap={0.5} mb={1}>
          <Grid container item xs={12}>
            <MxFormSubTitle label="Recursos" />
          </Grid>
          <Grid container item xs={12}>
            <MxFormDescriptionTitle label="¡Añade recursos para hacer tu propiedad aún más atractiva y destacar entre las demás!" />
          </Grid>
        </Grid>

        <Grid item xs={12} md={6} lg={6}>
          <LinksFormSections />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MultimediaStep;
